import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Container,
  Dialog,
  IconButton,
  Paper,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  selectClasses,
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  FormControlLabel,
  Chip,
  Divider
} from '@mui/material';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { useCallback, useEffect, useState, useMemo } from 'react';
import { dropdownFetch, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import ClearAllIcon from '@mui/icons-material/ClearAll';

const styles = {
  card: {
    borderRadius: 2,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e0e0e0'
  },
  table: {
    width: '100%',
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
      fontSize: '1rem'
    }
  },
  select: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 1
    }
  },
  checkbox: {
    color: 'primary.main',
    '&.Mui-checked': {
      color: 'primary.main'
    }
  }
};

export const Permission = () => {
  const [roles, setRoles] = useState([]);
  const [tabledata, setTabledata] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState({
    role: '',
    parent: '',
    child: '',
    grandChild: ''
  });
  const [isChecked, setIsChecked] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [render, setRender] = useState(false);
  
  const organizationData = useSelector((state) => state.organization);
  const data = useMemo(() => {
    return organizationData.find((item) => item.id === 'hospital')?.options || [];
  }, [organizationData]);

  const dataa = useMemo(() => {
    const selectedData = data.find((item) => item.id === selectedRoles.parent);
    if (!selectedData || selectedData.menu.length === 0) {
      return [];
    }
    return selectedData.menu;
  }, [data, selectedRoles.parent]);

  const dataaa = useMemo(() => {
    const selectedDataa = dataa.find((item) => item.id === selectedRoles.child);
    if (!selectedDataa || selectedDataa.children.length === 0) {
      return [];
    }
    if (selectedDataa.children) {
      let hasSubmenuChildren = false;
      selectedDataa.children.forEach((submenu) => {
        if (submenu.children) {
          hasSubmenuChildren = true;
        }
      });
      if (hasSubmenuChildren) {
        setRender(true);
      } else {
        setTabledata(selectedDataa.children);
      }
    }
    return selectedDataa.children;
  }, [dataa, selectedRoles.child]);

  const dataaaa = useMemo(() => {
    const selectedDataaa = dataaa.find((item) => item.id === selectedRoles.grandChild);
    if (!selectedDataaa) {
      return [];
    }
    if (!selectedDataaa.children) {
      return [selectedDataaa];
    }
    return selectedDataaa.children;
  }, [selectedRoles.grandChild]);

  useEffect(() => {
    if (dataaaa.length > 0) {
      setTabledata(dataaaa);
    }
  }, [dataaaa]);

  const extractIds = (organizationStore) => {
    return organizationStore ? organizationStore.map((item) => item.id) : [];
  };

  useEffect(() => {
    const fetchRolesData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/role/dropdown`);
        setRoles(response.data.data);
      } catch (error) {
        setError('Error fetching roles');
        console.error('Error fetching roles:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchRolesData();
  }, []);

  useEffect(() => {
    if (permissions['DatePermission']) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [permissions]);

  const handleRoleChange = (roleType) => async (e) => {
    const roleId = e.target.value;
    setSelectedRoles((prev) => ({ ...prev, [roleType]: roleId }));
    
    if (roleType === 'role' && roleId) {
      try {
        const response = await axios.get(`${BASE_URL}/role-master/${roleId}`);
        const rolePermissions = response.data.permissions.reduce((acc, perm) => {
          acc[perm] = true;
          return acc;
        }, {});
        setPermissions(rolePermissions);
      } catch (error) {
        console.error('Error fetching role permissions:', error);
      }
    }
    
    if (roleType === 'parent') {
      setSelectedRoles((prev) => ({ ...prev, child: '', grandChild: '' }));
      setRender(false);
      setTabledata([]);
    }
    
    if (roleType === 'child') {
      setSelectedRoles((prev) => ({ ...prev, grandChild: '' }));
      setRender(false);
      setTabledata([]);
    }
  };

  const handleCheckboxChangeDate = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChange = (action, permissionType) => {
    const permissionKey = `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}${permissionType.charAt(0).toUpperCase() + permissionType.slice(1)}`;
    setPermissions((prevPermissions) => ({
      ...prevPermissions,
      [permissionKey]: !prevPermissions[permissionKey]
    }));
  };

  // Select All functionality
  const handleSelectAll = () => {
    const newPermissions = { ...permissions };
    const actions = extractIds(tabledata);
    
    actions.forEach((action) => {
      ['Read', 'Write', 'Update', 'Print'].forEach((permissionType) => {
        const permissionKey = `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}${permissionType}`;
        newPermissions[permissionKey] = true;
      });
    });
    
    setPermissions(newPermissions);
  };

  // Clear All functionality
  const handleClearAll = () => {
    const newPermissions = { ...permissions };
    const actions = extractIds(tabledata);
    
    actions.forEach((action) => {
      ['Read', 'Write', 'Update', 'Print'].forEach((permissionType) => {
        const permissionKey = `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}${permissionType}`;
        newPermissions[permissionKey] = false;
      });
    });
    
    setPermissions(newPermissions);
  };

  const handleReset = () => {
    setSelectedRoles({
      role: '',
      parent: '',
      child: '',
      grandChild: ''
    });
    setRender(false);
    setTabledata([]);
    setPermissions({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRoles.role) {
      alert('Please select a role.');
      return;
    }
    
    const selectedPermissions = Object.keys(permissions).filter((key) => permissions[key]);
    let result = [...selectedPermissions];
    const additionalPermissions = ['Exit', 'Submit', 'Cancel', 'hospital'];
    
    additionalPermissions.forEach((permission) => {
      if (!result.includes(permission)) {
        result.push(permission);
      }
    });
    
    if (isChecked) {
      result.push('DatePermission');
    } else {
      result = result.filter((permission) => permission !== 'DatePermission');
    }
    
    try {
      await axios.put(`${BASE_URL}/role-master/update/${selectedRoles.role}`, { permissions: result });
      alert('Permissions updated successfully.');
      handleReset();
    } catch (error) {
      console.error('Error updating permissions:', error);
    }
  };

  return (
    <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
      <Container
        sx={{
          mt: 1,
          border: '0px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          width: '100%',
          maxWidth: 'none',
          minWidth: '100%',
          boxSizing: 'border-box'
        }}
      >
        <FormProvider onSubmit={handleSubmit}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
          >
            <Typography color="primary" variant="h4" sx={{ fontWeight: 600 }}>
              Permission Management
            </Typography>
          </Stack>

          <Grid container spacing={3}>
            {/* Role Selection Card */}
            <Grid item xs={12}>
              <Card sx={styles.card}>
                <CardHeader 
                  title="Role Configuration" 
                  titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                />
                <CardContent>
                  <Stack spacing={3}>
                    <FormControl fullWidth sx={styles.select}>
                      <InputLabel>Select Role</InputLabel>
                      <Select
                        value={selectedRoles.role}
                        onChange={handleRoleChange('role')}
                        label="Select Role"
                      >
                        <MenuItem value="">
                          <em>Select Role</em>
                        </MenuItem>
                        {roles.map((role) => (
                          <MenuItem key={role._id} value={role._id}>
                            {role.role}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {selectedRoles.role && (
                      <Box>
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                          Selected Role: <Chip 
                            label={roles.find(r => r._id === selectedRoles.role)?.role} 
                            color="primary" 
                            size="small" 
                          />
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Permission Hierarchy Card */}
            <Grid item xs={12}>
              <Card sx={styles.card}>
                <CardHeader 
                  title="Permission Hierarchy" 
                  titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                />
                <CardContent>
                  <Stack spacing={3}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth sx={styles.select}>
                          <InputLabel>Select Parent</InputLabel>
                          <Select
                            value={selectedRoles.parent}
                            onChange={handleRoleChange('parent')}
                            label="Select Parent"
                          >
                            <MenuItem value="">
                              <em>Select Parent</em>
                            </MenuItem>
                            {extractIds(data).map((role) => (
                              <MenuItem key={role} value={role}>
                                {role}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={handleCheckboxChangeDate}
                              sx={styles.checkbox}
                            />
                          }
                          label={
                            <Typography variant="body1" fontWeight="bold">
                              Date Permission
                            </Typography>
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth sx={styles.select}>
                          <InputLabel>Select Child</InputLabel>
                          <Select
                            value={selectedRoles.child}
                            onChange={handleRoleChange('child')}
                            label="Select Child"
                          >
                            <MenuItem value="">
                              <em>Select Child</em>
                            </MenuItem>
                            {extractIds(dataa).map((role) => (
                              <MenuItem key={role} value={role}>
                                {role}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      {selectedRoles.child && render && (
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth sx={styles.select}>
                            <InputLabel>Select Grand Child</InputLabel>
                            <Select
                              value={selectedRoles.grandChild}
                              onChange={handleRoleChange('grandChild')}
                              label="Select Grand Child"
                            >
                              <MenuItem value="">
                                <em>Select Grand Child</em>
                              </MenuItem>
                              {extractIds(dataaa).map((role) => (
                                <MenuItem key={role} value={role}>
                                  {role}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Permissions Table Card */}
            {tabledata.length > 0 && (
              <Grid item xs={12}>
                <Card sx={styles.card}>
                  <CardHeader 
                    title="Permissions"
                    action={
                      <Stack direction="row" spacing={1}>
                        <Button
                          startIcon={<SelectAllIcon />}
                          onClick={handleSelectAll}
                          variant="outlined"
                          color="primary"
                          size="small"
                        >
                          Select All
                        </Button>
                        <Button
                          startIcon={<ClearAllIcon />}
                          onClick={handleClearAll}
                          variant="outlined"
                          color="secondary"
                          size="small"
                        >
                          Clear All
                        </Button>
                      </Stack>
                    }
                    titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                  />
                  <CardContent>
                    <TableContainer>
                      <Table sx={styles.table}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Label</TableCell>
                            <TableCell align="center">Read</TableCell>
                            <TableCell align="center">Write</TableCell>
                            <TableCell align="center">Update</TableCell>
                            <TableCell align="center">Print</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {extractIds(tabledata).map((action) => (
                            <TableRow key={action} hover>
                              <TableCell>
                                <Typography variant="body1" fontWeight="medium">
                                  {action.toUpperCase()}
                                </Typography>
                              </TableCell>
                              {['Read', 'Write', 'Update', 'Print'].map((permissionType) => (
                                <TableCell key={permissionType} align="center">
                                  <Checkbox
                                    checked={
                                      permissions[
                                        `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}${permissionType}`
                                      ] || false
                                    }
                                    onChange={() => handleCheckboxChange(action, permissionType.toLowerCase())}
                                    sx={styles.checkbox}
                                  />
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {/* Action Buttons */}
            <Grid item xs={12}>
              <Card sx={styles.card}>
                <CardContent>
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button
                      onClick={handleReset}
                      variant="outlined"
                      color="secondary"
                      size="large"
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={!selectedRoles.role}
                    >
                      Save Permissions
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </FormProvider>
      </Container>
    </Paper>
  );
};